// Resolve actor from the authenticated Redux user so callers cannot forge
// audit-log identity via a client-supplied `actor` argument. Returns null
// when the session is missing an adminid (caller should abort).
export const resolveActorFromAuth = (getState) => {
    const authUser = getState()?.AuthReducer?.user;
    if (!authUser?.adminid) return null;
    return { id: authUser.adminid, type: authUser.companyInfo?.org ?? null };
};
